<template>
  <div class="have" v-if="resultList.length">
      <template v-for="(item, i) in resultList">
        <div style="border:1px solid #ddd;margin-bottom:15px;" :key="item.sessionCode">
          <div class="header" :key="i">
            <h1 @click="routerPush(item.sessionCode)">{{ item.name }}</h1>
            <div class="headerSize">
              预展时间：<span>{{
                item.pc_extra_info[10].text
                  ? item.pc_extra_info[10].text
                  : "已延期，开拍时间待定"
              }}</span>
            </div>
            <div class="headerSize">预展地点：<span>{{ item.pc_extra_info[11].text }}</span></div>
            <div class="headerSize">
              拍卖时间：<span>{{ item.extraInfo[1].text }}</span>
            </div>
            <div class="headerSize">
              拍卖地点：<span>{{ item.extraInfo[0].text }}</span>
            </div>
            <div class="headerSize">
              专场信息：<span>{{ `${item.specialsList.length}` }}个</span>
            </div>
          </div>
          <!-- swiper -->
          <div class="swiper" :key="i" v-if="swiperList[i] && swiperList[i].length">
            <el-carousel :indicator-position="swiperList[i].length > 1 ? 'outside' : 'none'" height="auto" :autoplay="false" arrow="never">
              <template v-for="(data, j) in swiperList[i]">
                <el-carousel-item :key="j" :label="j + 1">
                  <div class="main" v-for="(main, g) in data" :key="g">
                    <div class="mainIng"  @click="swiperPush(main.specialCode)">
                      <template v-if="main.coverPic">
                        <img :src="main.coverPic" style="width:100%;height:100%;object-fit: cover;">
                      </template>
                      <template v-else>
                        加载中...
                      </template>
                    </div>
                    <div class="maintext">
                      <h1 @click="swiperPush(main.specialCode)">{{ main.name }}</h1>
                      <div>拍品数量：{{ main.pc_extra_info[2].text }}</div>
                      <div>拍卖时间：{{ main.extraInfo[1].text }}</div>
                      <div>拍卖地点：{{ main.extraInfo[2].text }}</div>
                    </div>
                  </div>
                </el-carousel-item>
              </template>
            </el-carousel>
          </div>
      </div>
      </template>
      <pagination v-if="pages > 1" :item="pages" @clickPagination="$emit('clickPagination', $event)"/>
  </div>
</template>

<script>
import pagination from '@/views/auctionCompany/components/auctionResult/pagination.vue'

export default {
  name: "have",
  props: ["resultList", "swiperList", "pages"],
  mounted() {
  },
  methods: {
    routerPush(code) {
      this.$router.push(`/meeting_detail/${code}`)
    },
    swiperPush(code) {
      this.$router.push(`/special_detail/${code}`)
    }
  },
  components: {
    pagination
  }
};
</script>

<style lang="scss" scoped>
@import "./index.scss";
</style>